export default "__VITE_ASSET__vUD7D9m4__"